// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115

// OOO Circular: services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.ts > services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.encoding.ts
import {
  BrowserChecker,
  Int64,
  UInt64,
  Number,
  Exception
} from "./microsoft.bond";

export class Utf8 {
  static GetBytes(value: string): number[] {
    var array: any[] = []; // !!! StrictNullCheck Violation
    for (var i = 0; i < value.length; ++i) {
      var char = value.charCodeAt(i);
      if (char < 0x80) {
        array.push(char);
      } else if (char < 0x800) {
        array.push(0xc0 | (char >> 6), 0x80 | (char & 0x3f));
      } else if (char < 0xd800 || char >= 0xe000) {
        array.push(
          0xe0 | (char >> 12),
          0x80 | ((char >> 6) & 0x3f),
          0x80 | (char & 0x3f)
        );
      } else {
        char =
          0x10000 + (((char & 0x3ff) << 10) | (value.charCodeAt(++i) & 0x3ff));
        array.push(
          0xf0 | (char >> 18),
          0x80 | ((char >> 12) & 0x3f),
          0x80 | ((char >> 6) & 0x3f),
          0x80 | (char & 0x3f)
        );
      }
    }
    return array;
  }
}

export class Base64 {
  static GetString(inArray: number[]): string {
    var lookup =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var output: any[] = []; // !!! StrictNullCheck Violation
    var paddingBytes = inArray.length % 3;
    var i, temp, length;

    var toBase64 = (num: number): string => {
      return [
        lookup.charAt((num >> 18) & 0x3f),
        lookup.charAt((num >> 12) & 0x3f),
        lookup.charAt((num >> 6) & 0x3f),
        lookup.charAt(num & 0x3f)
      ].join("");
    };

    for (i = 0, length = inArray.length - paddingBytes; i < length; i += 3) {
      temp = (inArray[i] << 16) + (inArray[i + 1] << 8) + inArray[i + 2];
      output.push(toBase64(temp));
    }

    switch (paddingBytes) {
      case 1:
        temp = inArray[inArray.length - 1];
        output.push(lookup.charAt(temp >> 2));
        output.push(lookup.charAt((temp << 4) & 0x3f));
        output.push("==");
        break;

      case 2:
        temp = (inArray[inArray.length - 2] << 8) + inArray[inArray.length - 1];
        output.push(lookup.charAt(temp >> 10));
        output.push(lookup.charAt((temp >> 4) & 0x3f));
        output.push(lookup.charAt((temp << 2) & 0x3f));
        output.push("=");
        break;
    }
    return output.join("");
  }
}

export class Varint {
  static GetBytes(value: number): number[] {
    var array: any[] = []; // !!! StrictNullCheck Violation
    while (value & 0xffffff80) {
      array.push((value & 0x7f) | 0x80);
      value >>>= 7;
    }
    array.push(value & 0x7f);
    return array;
  }
}

export class Varint64 {
  static GetBytes(value: UInt64): number[] {
    var low = value.low;
    var high = value.high;
    var array: any[] = []; // !!! StrictNullCheck Violation
    while (high || 0xffffff80 & low) {
      array.push((low & 0x7f) | 0x80);
      low = ((high & 0x7f) << 25) | (low >>> 7);
      high >>>= 7;
    }
    array.push(low & 0x7f);
    return array;
  }
}

export class Float {
  static GetBytes(value: number): number[] {
    if (BrowserChecker.IsDataViewSupport()) {
      var view = new DataView(new ArrayBuffer(4));
      view.setFloat32(0, value, true /*littleEndian*/);

      var array: any[] = []; // !!! StrictNullCheck Violation
      for (var i = 0; i < 4; ++i) {
        array.push(view.getUint8(i));
      }
      return array;
    } else {
      return FloatUtils.ConvertNumberToArray(value, false /*isDouble*/);
    }
  }
}

// Note: see notes of Float.
export class Double {
  static GetBytes(value: number): number[] {
    if (BrowserChecker.IsDataViewSupport()) {
      var view = new DataView(new ArrayBuffer(8));
      view.setFloat64(0, value, true /*littleEndian*/);

      var array: any[] = []; // !!! StrictNullCheck Violation
      for (var i = 0; i < 8; ++i) {
        array.push(view.getUint8(i));
      }
      return array;
    } else {
      return FloatUtils.ConvertNumberToArray(value, true /*isDouble*/);
    }
  }
}

export class Zigzag {
  static EncodeZigzag16(value: number): number {
    value = Number.ToInt16(value);
    return (value << 1) ^ (value >> (2 /*sizeof(short)*/ * 8 - 1));
  }

  static EncodeZigzag32(value: number): number {
    value = Number.ToInt32(value);
    return (value << 1) ^ (value >> (4 /*sizeof(int)*/ * 8 - 1));
  }

  static EncodeZigzag64(value: Int64): UInt64 {
    var low = value.low;
    var high = value.high;
    var tmpH = (high << 1) | (low >>> 31);
    var tmpL = low << 1;
    if (high & 0x80000000) {
      tmpH = ~tmpH;
      tmpL = ~tmpL;
    }

    var res = new UInt64("0");
    res.low = tmpL;
    res.high = tmpH;
    return res;
  }
}

export class DecodingUtf8 {
  static GetString(data: number[]): string {
    var res: any[] = []; // !!! StrictNullCheck Violation
    for (var i = 0; i < data.length; ++i) {
      var c1 = data[i];
      if (c1 <= 191) {
        res.push(String.fromCharCode(c1));
      } else if (c1 <= 223) {
        var c2 = data[++i];
        res.push(String.fromCharCode(((c1 & 31) << 6) | (c2 & 63)));
      } else if (c1 <= 239) {
        var c2 = data[++i];
        var c3 = data[++i];
        res.push(
          String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        );
      } else {
        var c2 = data[++i];
        var c3 = data[++i];
        var c4 = data[++i];
        c1 =
          ((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63);
        c1 -= 0x10000;
        res.push(String.fromCharCode(0xd800 | ((c1 >> 10) & 0x3ff)));
        res.push(String.fromCharCode(0xdc00 | (c1 & 0x3ff)));
      }
    }
    return res.join("");
  }
}

export class DecodingBase64 {
  static GetBytes(base64Str: string): number[] {
    var lookup =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var res: any[] = []; // !!! StrictNullCheck Violation
    for (var i = 0; i < base64Str.length; ++i) {
      var byte1 = lookup.indexOf(base64Str.charAt(i++));
      var byte2 = lookup.indexOf(base64Str.charAt(i++));
      var byte3 = lookup.indexOf(base64Str.charAt(i++));
      var byte4 = lookup.indexOf(base64Str.charAt(i));

      res.push((byte1 << 2) | (byte2 >> 4));
      if (byte3 >= 0) {
        res.push(((byte2 << 4) & 0xf0) | (byte3 >> 2));

        if (byte4 >= 0) {
          res.push(((byte3 << 6) & 0xc0) | byte4);
        }
      }
    }
    return res;
  }
}

export class DecodingVarint {
  static GetInt64(buffer: number[]): Int64 {
    var int64 = new Int64("0");
    var data = this._Read(buffer);
    int64.low = data[0];
    if (data.length > 1) {
      int64.high = data[1];
    }
    return int64;
  }

  static GetNumber(buffer: number[]): number {
    return this._Read(buffer)[0];
  }

  private static _Read(buffer: number[]): number[] {
    var result: any[] = []; // !!! StrictNullCheck Violation
    var tmp = 0;
    var hasMore = true;
    var readedBits = 0;

    // first, lets try to read the first 32 bits
    while (hasMore) {
      var raw = buffer.shift();
      hasMore = (raw!!! & 0x80) != 0;
      raw = raw!!! & 0x7f;
      if (readedBits < 28) {
        tmp |= raw << readedBits;
        readedBits += 7;
      } else {
        // only lower 4 bits can be put
        tmp |= raw << readedBits;
        result.push(tmp);
        tmp = raw >> 4;
        readedBits = 3;
        break;
      }
    }

    // then, read the second 32 bits
    while (hasMore) {
      var raw = buffer.shift();
      hasMore = (raw!!! & 0x80) != 0;
      raw = raw!!! & 0x7f;
      tmp |= raw << readedBits;
      readedBits += 7;
      if (readedBits >= 32) {
        break;
      }
    }
    result.push(tmp);
    return result;
  }
}

export class DecodingFloat {
  static GetNumber(buffer: number[]): number {
    if (BrowserChecker.IsDataViewSupport()) {
      var view = new DataView(new ArrayBuffer(4));
      for (var i = 0; i < 4; ++i) {
        view.setUint8(i, buffer[i]);
      }
      return view.getFloat32(0, true /*littleEndian*/);
    } else {
      return FloatUtils.ConvertArrayToNumber(buffer, false /*isDouble*/);
    }
  }
}

export class DecodingDouble {
  static GetNumber(buffer: number[]): number {
    if (BrowserChecker.IsDataViewSupport()) {
      var view = new DataView(new ArrayBuffer(8));
      for (var i = 0; i < 8; ++i) {
        view.setUint8(i, buffer[i]);
      }
      return view.getFloat64(0, true /*littleEndian*/);
    } else {
      return FloatUtils.ConvertArrayToNumber(buffer, true /*isDouble*/);
    }
  }
}

export class DecodingZigzag {
  static DecodeZigzag16(value: number): number {
    return ((((0xffff & value) >>> 1) ^ -(value & 1)) << 16) >> 16;
  }

  static DecodeZigzag32(value: number): number {
    return (value >>> 1) ^ -(value & 1);
  }

  static DecodeZigzag64(value: UInt64): UInt64 {
    // implement
    // (value >>> 1) ^ (-(value & 1))
    var tmpH = value.high & 1;
    var high = value.high >>> 1;
    var tmpL = value.low & 1;
    var low = value.low >>> 1;
    low = (tmpH << 31) | low;
    if (tmpL) {
      low ^= 0xffffffff;
      high ^= 0xffffffff;
    }

    var res = new UInt64("0");
    res.low = low;
    res.high = high;
    return res;
  }
}

/** This class will be used to convert float/double to byte array on browsers which doesn't
        support html5.

        Format: IEEE-754, littleEndian, http://en.wikipedia.org/wiki/IEEE_754-1985

        \note
        1. Don't have negative zero. All zero will be positive zero.
        2. If the buffer array passed to ConvertArrayToFloat() is actual NaN or Inifinity value,
            exception will be raised.
    */
class FloatUtils {
  private static _floatZero = [0x00, 0x00, 0x00, 0x00];
  private static _doubleZero = [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00];
  private static _floatInifinity = [0x00, 0x00, 0x80, 0x7f];
  private static _floatNegInifinity = [0x00, 0x00, 0x80, 0xff];
  private static _doubleInifinity = [
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0xf0,
    0x7f
  ];
  private static _doubleNegInifinity = [
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0xf0,
    0xff
  ];

  static ConvertNumberToArray(num: number, isDouble: boolean): number[] {
    if (!num) {
      return isDouble ? this._doubleZero : this._floatZero;
    }

    var exponentBits = isDouble ? 11 : 8;
    var precisionBits = isDouble ? 52 : 23;

    // follow IEEE-754, exponent bias is 2^(k-1)-1 where k is the number of bits
    // in the exponent: http://en.wikipedia.org/wiki/Exponent_bias
    var bias = (1 << (exponentBits - 1)) - 1;
    var minExponent = 1 - bias;
    var maxExponent = bias;

    var sign = num < 0 ? 1 : 0;
    num = Math.abs(num);
    var intPart = Math.floor(num);
    var floatPart = num - intPart;

    var len = 2 * (bias + 2) + precisionBits;
    var buffer = new Array(len);
    var i = 0;
    while (i < len) {
      buffer[i++] = 0;
    }

    // caculate the intPart
    i = bias + 2;
    while (i && intPart) {
      buffer[--i] = intPart % 2;
      intPart = Math.floor(intPart / 2);
    }

    // caculate the floatPart
    i = bias + 1;
    while (i < len - 1 && floatPart > 0) {
      floatPart *= 2;
      if (floatPart >= 1) {
        buffer[++i] = 1;
        --floatPart;
      } else {
        buffer[++i] = 0;
      }
    }

    // find the first 1
    var firstBit = 0;
    for (; firstBit < len && !buffer[firstBit]; ++firstBit);

    // caculate exponent
    var exponent = bias + 1 - firstBit;

    // caculate round
    var lastBit = firstBit + precisionBits;
    if (buffer[lastBit + 1]) {
      for (i = lastBit; i > firstBit; --i) {
        if ((buffer[i] = 1 - buffer[i])) {
          break;
        }
      }
      if (i == firstBit) {
        ++exponent;
      }
    }

    // check overflow
    if (exponent > maxExponent || intPart) {
      if (sign) {
        return isDouble ? this._doubleNegInifinity : this._floatNegInifinity;
      } else {
        return isDouble ? this._doubleInifinity : this._floatInifinity;
      }
    } else if (exponent < minExponent) {
      return isDouble ? this._doubleZero : this._floatZero;
    }

    // caculate the result
    if (isDouble) {
      var high = 0;
      for (i = 0; i < 20; ++i) {
        high = (high << 1) | buffer[++firstBit];
      }

      var low = 0;
      for (; i < 52; ++i) {
        low = (low << 1) | buffer[++firstBit];
      }

      high |= (exponent + bias) << 20;
      high = (sign << 31) | (high & 0x7fffffff);

      var resArray = [
        low & 0xff,
        (low >> 8) & 0xff,
        (low >> 16) & 0xff,
        low >>> 24,
        high & 0xff,
        (high >> 8) & 0xff,
        (high >> 16) & 0xff,
        high >>> 24
      ];
      return resArray;
    } else {
      var result = 0;
      for (i = 0; i < 23; ++i) {
        result = (result << 1) | buffer[++firstBit];
      }

      result |= (exponent + bias) << 23;
      result = (sign << 31) | (result & 0x7fffffff);

      var resArray = [
        result & 0xff,
        (result >> 8) & 0xff,
        (result >> 16) & 0xff,
        result >>> 24
      ];
      return resArray;
    }
  }

  static ConvertArrayToNumber(buffer: number[], isDouble: boolean): number {
    var exponentBits = isDouble ? 11 : 8;
    var bias = (1 << (exponentBits - 1)) - 1;
    var sign = (buffer[isDouble ? 7 : 3] & 0x80) != 0;
    var exponent = isDouble
      ? ((buffer[7] & 0x7f) << 4) | ((buffer[6] & 0xf0) >> 4)
      : ((buffer[3] & 0x7f) << 1) | ((buffer[2] & 0x80) >> 7);

    // check the buffer is valid or not. If it is invalid (NaN, Infinitive), throw execption.
    if (exponent == 0xff) {
      throw new Exception("Not a valid float/double buffer.");
    }

    var res = 1;
    var e = 1;
    if (isDouble) {
      var high =
        ((buffer[6] & 0xf) << 28) |
        ((buffer[5] & 0xff) << 20) |
        ((buffer[4] & 0xff) << 12);
      var low =
        (buffer[3] << 24) |
        ((buffer[2] & 0xff) << 16) |
        ((buffer[1] & 0xff) << 8) |
        (buffer[0] & 0xff);
      if (!exponent && !high && !low) {
        return 0.0;
      }
      for (var i = 0; i < 20; ++i) {
        e /= 2;
        if (high < 0) {
          res += e;
        }
        high <<= 1;
      }
      for (var i = 0; i < 32; ++i) {
        e /= 2;
        if (low < 0) {
          res += e;
        }
        low <<= 1;
      }
    } else {
      var data =
        ((buffer[2] & 0x7f) << 25) |
        ((buffer[1] & 0xff) << 17) |
        ((buffer[0] & 0xff) << 9);
      if (!exponent && !data) {
        return 0.0;
      }
      for (var i = 0; i < 23; ++i) {
        e /= 2;
        if (data < 0) {
          res += e;
        }
        data <<= 1;
      }
    }
    res *= Math.pow(2, exponent - bias);
    return sign ? 0 - res : res;
  }
}
